import { HTMLMotionProps, motion } from 'framer-motion'
import { cn } from '~utils/cn'

import useDelayedState from '~hooks/use-delayed-state'
import { useSelectBox } from './context'

type Props = HTMLMotionProps<'div'>

const SelectBoxDropdown = ({ children, ...props }: Props) => {
  const { className } = props
  const { open, label } = useSelectBox()
  const show = useDelayedState({ active: open })

  return (
    <motion.div
      {...props}
      initial={{ opacity: 0, scale: 1 }}
      animate={open ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 1 }}
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      className={cn(
        'absolute top-[64px] z-floated h-fit w-full overflow-hidden rounded-xl border border-solid border-gray-200 bg-white shadow-elevation-1 transition-all motion-reduce:transition-none',
        'dark:bg-gray-800 dark:border-gray-800',
        label && 'top-[88px]',
        className
      )}
    >
      {show && children}
    </motion.div>
  )
}

export default SelectBoxDropdown
